import React from 'react'

import { Typography } from 'antd'

import EmptyData from '../../assets/images/ico_dashboard.svg'

export const EmptyDashboard = () => {
  return (
    <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: 310, background: '#F1F3F5' }}>
      <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
      <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18 }}>
        {'Sem dados'}
      </Typography>
      <Typography style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -50 }}>
        {'Aplique ou altere o filtro para'}
      </Typography>
      <Typography style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -120 }}>
        {'exibir dados.'}
      </Typography>
    </div>
  )
}
